import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import resources from '@resources';
import paths from '@paths';
import {Props} from './types';

export const update = async (
  values: any,
  formikHelpers: FormikHelpers<any>,
  action: UsersAction,
  id: string
) => {
  try {
    await action.users.updateUser(values, id);
    notify(
      resources.users.getNotifyMessage('success', 'update', 'admin'),
      'success'
    );
    formikHelpers.setSubmitting(false);
  } catch (error) {
    notify(
      resources.users.getNotifyMessage('error', 'update', 'admin'),
      'error'
    );
    formikHelpers.setSubmitting(false);
  }
};

export const deleteUser = async (props: Props, id: string) => {
  try {
    await props.actions.users.deleteUser(id);
    props.history.push(paths.admin.main);
    notify(
      resources.users.getNotifyMessage('success', 'delete', 'admin'),
      'success'
    );
  } catch (error) {
    notify(
      resources.users.getNotifyMessage('error', 'delete', 'admin'),
      'error'
    );
  }
};
